// import { json } from 'react-router-dom'
import { useOutletContext } from 'react-router-dom';
import Axois from '../utils/axios'
// import EventEmitter from '../utils/eventEmitter';



export const loadSettings = async () => {
  let response = await Axois.get('/settings').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


const useSettingsAPI = () => {
  const { success } = useOutletContext();

  const save = async (data, success, error) => {
    try {
      const response = await Axois.post('/settings', data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('tax_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  };

  const update = async (data) => {
    try {
      const respnse = await Axois.put('/settings/', data);
      const responseData = await respnse.data;
      success(responseData.message);
      // EventEmitter.dispatch('tax_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useSettingsAPI;